import styled from "styled-components";
import { COLORS } from "../../../const/colors";

export const CertSection = styled.section`
  padding: 6rem 0 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, ${COLORS.BLACK_10} 0%, transparent 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      ${COLORS.ORANGE_10} 0%,
      ${COLORS.DARK_BLUE_10} 50%,
      transparent 70%
    );
    top: 20%;
    left: -150px;
    z-index: -1;
  }

  @media screen and (min-width: 992px) {
    padding: 7rem 0 3rem;
  }
`;

export const CertContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: grid;
  gap: 2rem;
  padding-top: 2rem;

  @media screen and (min-width: 576px) {
    justify-content: center;
    padding: 2rem;
  }

  @media screen and (min-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem;
  }

  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
  }
`;

export const CertCard = styled.div`
  background-color: ${(props) =>
    props.light ? COLORS.WHITE : COLORS.DARK_SURFACE};
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 10px 30px ${COLORS.BLACK_10};
  transition: all 0.4s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 1rem;
    padding: 1px;
    background: linear-gradient(135deg, ${COLORS.ORANGE}, ${COLORS.DARK_BLUE});
    background-size: 300% 100%;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  @keyframes certBorderAnimation {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 300% 0%;
    }
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px ${COLORS.BLACK_20};

    &::before {
      animation: certBorderAnimation 3s linear infinite;
    }
  }

  @media screen and (min-width: 992px) {
    border-radius: 1.25rem;
  }
`;

export const CertImg = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.6s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media screen and (min-width: 992px) {
    height: 220px;
  }
`;

export const CertTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin: 1.25rem 1.25rem 0.75rem;
  color: ${(props) =>
    props.light ? COLORS.TEXT_PRIMARY : COLORS.DARK_TEXT_PRIMARY};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 2.75rem;
`;

export const CertButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.ORANGE};
  color: ${COLORS.WHITE};
  padding: 0.75rem 1.25rem;
  margin: 0 0.5rem 1.25rem 1.25rem;
  border-radius: 0.75rem;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 10px ${COLORS.ORANGE_30};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${COLORS.WHITE_30},
      transparent
    );
    transition: all 0.6s ease;
  }

  &.btn_ghost {
    background-color: transparent;
    border: 1px solid ${COLORS.ORANGE};
    color: ${COLORS.ORANGE};
    box-shadow: 0 4px 8px ${COLORS.ORANGE_20};
  }

  &:hover {
    background-color: ${COLORS.ACCENT};
    transform: translateY(-3px);
    box-shadow: 0 6px 15px ${COLORS.ACCENT};

    &::before {
      left: 100%;
    }
  }

  &.btn_ghost:hover {
    background-color: ${COLORS.ORANGE_10};
    border-color: ${COLORS.ACCENT};
    color: ${COLORS.ACCENT};
    box-shadow: 0 4px 8px ${COLORS.ORANGE_20};
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px ${COLORS.ORANGE_30};
  }

  &:disabled {
    background-color: ${COLORS.LIGHT_GRAY};
    cursor: not-allowed;
    box-shadow: none;

    &:hover {
      transform: none;
    }
  }
`;

// export const ButtonMore = styled.a`
//   cursor: pointer;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 0.5rem;
//   font-size: 0.85rem;
//   margin: 1rem;
//   padding: 0.25rem 0.75rem;
//   width: fit-content;
//   transition: 0.2s;
//   color: hsla(0, 70%, 100%, 1);
//   background-color: hsla(0, 100%, 45%, 1);

//   &:hover {
//     background-color: hsla(0, 100%, 29%, 1);
//     color: hsl(219, 15%, 95%);
//   }
// `;
